// Business mobile in international format without "+", e.g. "614XXXXXXXX".
// Empty = WhatsApp/SMS links stay hidden.
export const PHONE = "";

export function track(event: string, params: Record<string, string> = {}) {
  (window as any).gtag?.("event", event, params);
}
